import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { CurrencyPipe } from "@angular/common";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";
import { SharedModule } from "@shared/shared.module";
import { AppComponent } from "./app.component";
import { APP_ROUTES } from "./app.routes";
import { CalendarioPagoPensionModule } from "./calendario-pago-pension/calendario-pago-pension.module";
import { CambioViaPagoPensionModule } from "./cambio-via-pago-pension/cambio-via-pago-pension.module";
import { CongelamientoSaldosModule } from "./congelamiento-saldos/congelamiento-saldos.module";
import { EstadoTramitePensionModule } from "./estado-tramite-pension/estado-tramite-pension.module";
import { HomeDevComponent } from "./home-dev/home-dev.component";
import { InformacionPagoPensionModule } from "./informacion-pago-pension/informacion-pago-pension.module";
import { InformePensionesModule } from "./informe-pensiones/informe-pensiones.module";
import { ReformaPensionesModule } from "./reforma-pensiones/reforma-pensiones.module";
import { TramitePensionModule } from "./tramite-pension/tramite-pension.module";
import { TramitePensionInvalidezModule } from "./tramite-pension-invalidez/tramite-pension-invalidez.module";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { provideFirestore, getFirestore } from "@angular/fire/firestore";
import { environment } from "src/environments/environment.qa";


@NgModule({
  declarations: [AppComponent, HomeDevComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(APP_ROUTES,{
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
    IonicModule.forRoot({ mode: "md", animated: false }),
    CambioViaPagoPensionModule,
    CongelamientoSaldosModule,
    TramitePensionModule,
    TramitePensionInvalidezModule,
    CalendarioPagoPensionModule,
    InformacionPagoPensionModule,
    EstadoTramitePensionModule,
    ReformaPensionesModule,
    InformePensionesModule,
    SharedModule,
    IonicStorageModule.forRoot(),
  ],
  providers: [
    CurrencyPipe,
    provideFirebaseApp(() => initializeApp(environment.FIREBASE_CONFIG)),
    provideFirestore(() => getFirestore()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
